import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialog } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
// import { Clipboard } from '@angular/cdk/clipboard';
import { ClipboardService } from 'ngx-clipboard';
import { ClipBoardService as messageService} from 'src/app/services/clipboard.service';
import { DeleteLinkJobComponent } from '../delete-link-job/delete-link-job.component';

@Component({
  selector: 'app-campaign-job-links',
  templateUrl: './campaign-job-links.component.html',
  styleUrls: ['./campaign-job-links.component.scss']
})
export class CampaignJobLinksComponent implements OnInit {

  authToken = localStorage.getItem('token')
  adminUser:any;
  selectedUser:any;
  links: { id: number, value: string }[] = [];
  allLinks:any;
  nextId: number = 1;
  copiedIndex: number | null = null;
  allData:any
  title:any;
  labelText:any;
  userInfo = JSON.parse(localStorage.getItem("userInfo"));
  deleteLinkJobComponent:MatDialogRef<DeleteLinkJobComponent>;
  btnStatus = false;
  allLinkInfo:any = {};
  campaignId:any;
  constructor(
    private dialogRef: MatDialogRef<CampaignJobLinksComponent>,
    private _serverService:ServerService,
    private clipboardService: ClipboardService,
    private clipBoardMessageService:messageService,
    private dialog:MatDialog,

    @Inject(MAT_DIALOG_DATA) public data
  ) { 
    // console.log(this.data.job_table_type)
    this.allData = this.data;
    // console.log(this.allData)
    if(this.data.job_table_type == 'escalation'){
      this.allLinks = this.data.supporting_links;
      this.title = "Escalation"
      this.labelText = "Escalation Link"
    }
    else{
      this.allLinks = this.data.open_file_link;
      this.title = 'Creative Job'
      this.labelText = "Open Files link"
    }
    
    // console.log(this.allLinks)
  }

  ngOnInit() {
    localStorage.setItem('link_deletion_job','false')
    // console.log(this.data)
    this.campaignId = this.data.campaign_id
  }

  close() {
    this.dialogRef.close();
}
toggleIconColor(index: number) {
  this.copiedIndex = this.copiedIndex === index ? null : index;
}

addLink(): void {
  this.links.push({ id: this.nextId++, value: '' });
}


copy(text:any,i:any){
  // this.clipboard.copyText();
  this.clipboardService.copyFromContent(text);
  this.toggleIconColor(i)
}

removeLink(index: number): void {
  this.links.splice(index, 1);
}
apply(){
  this.btnStatus = true;
  // let arrayOfStrings = this.links.map(link => 
  //   link.value);
    let arrayOfStrings = this.links
    .map(link => link.value)
    .filter(value => value.trim() !== ''); // Filter out empty values
  this.allLinks = [...arrayOfStrings,...this.allLinks]
  // console.log(this.allLinks);
  // let url = this.data.id;
  // const formData = new FormData()
  const formData: FormData = new FormData();
  // formData.append('open_file_link[]',this.allLinks);

  let url;
 
  if(this.data.job_table_type == 'escalation'){
    url = 'campaign_module/escalation/'+this.data.id;
    this.allLinks.forEach(link => formData.append('supporting_links[]',link));
  }
  else{
    url = 'campaign_module/creative_jobs/'+this.data.id;
    this.allLinks.forEach(link => formData.append('open_file_link[]',link));
  }
  formData.append('campaign_id',this.allData.campaign_id);
  
  this._serverService.updateCreativeJobDetails(url,formData,this.authToken).subscribe((data)=>{
    // console.log(data)
    this.clipBoardMessageService.showMessgeInText("Link Created Succesfully", "success-snackbar")
    this.dialogRef.close(data);
  },
  error => {
   console.error('Link Creation failed', error);
   this.btnStatus = false;
   // this.showComponentLoader = false;
 })
}
openLink(item){
  if (!item.startsWith('https:')) {
    item = 'https://' + item;
  }
  window.open(item, '_blank');
}
deleteLink(item,id,link){
  this.allLinkInfo['job_id'] =this.data.id
  this.allLinkInfo['all_links'] = item; 
  this.allLinkInfo['link_id'] = id; 
  this.allLinkInfo['extra_parameter'] = this.campaignId;
  this.allLinkInfo['link'] = link; 
  this.allLinkInfo['job_name'] = this.data.job_table_type;
  // console.log(this.allLinkInfo)
  this.deleteLinkJobComponent = this.dialog.open(DeleteLinkJobComponent, {
    hasBackdrop: true,
    disableClose: false,
    autoFocus: true,
    width: '520px',
    panelClass: 'blue-snackbar',
    data: this.allLinkInfo
  });
  this.deleteLinkJobComponent.afterClosed().subscribe(result => {
    if(result != undefined ){
      this.allLinks = result;
    }
    // console.log(result)
  })
}
}